import { render, staticRenderFns } from "./CompanyCrawlRequestsView.vue?vue&type=template&id=6c4d80e8&"
import script from "./CompanyCrawlRequestsView.vue?vue&type=script&lang=js&"
export * from "./CompanyCrawlRequestsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports